module.exports = __webpack_public_path__ + "static/2-554c5b6adbde97af16509d288d1ef06e.png";